import { render, staticRenderFns } from "./insure-info-detail.vue?vue&type=template&id=520af43a&"
import script from "./insure-info-detail.vue?vue&type=script&lang=js&"
export * from "./insure-info-detail.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports